import { creatorbase, creatorbaseQueries, queryHelpers } from '@round/api';
import { useQueryClient } from '@tanstack/react-query';
import useReportId from '../../hooks/useReportId';

export default function useInvalidateReportCampaigns() {
    const queryClient = useQueryClient();
    const reportId = useReportId();

    return (platform: creatorbase.Platform) => {
        if (!reportId) {
            return Promise.resolve();
        }

        return queryClient.invalidateQueries({
            queryKey: creatorbaseQueries.campaigns.keys.lists(),
            predicate: (query) => {
                const { params } = queryHelpers.parseQueryKey(
                    query.queryKey as queryHelpers.QueryKey<creatorbase.GetCampaignsParams>
                );
                return params?.report_id === reportId && params?.platform === platform;
            },
        });
    };
}
